export default function WorkGallery5() {
  return (
    <section className="py-10">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0 flex flex-col gap-4">

        {/* Row 1 */}

                    <div className="rounded-3xl overflow-hidden aspect-square">

            <img
              src="/roots6.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots1.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots2.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/roots16.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>
  

        {/* Row 2 */}

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots3.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots4.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots5.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>
  

        {/* Row 3 */}
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots6.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/roots17.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

<div className="hidden sm:block rounded-3xl overflow-hidden">
  <img
    src="/roots7.jpg"
    alt="Petrol station"
    className="w-full h-full object-cover block"
  />
</div>

<div className="hidden sm:block rounded-3xl overflow-hidden">
  <img
    src="/roots8.jpg"
    alt="Petrol station"
    className="w-full h-full object-cover block"
  />
</div>


        {/* Row 4 */}
       
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots9.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots10.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots11.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/roots18.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots12.jpg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots13.jpg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots14.jpg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/roots19.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/roots15.jpg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>


          
          


      </div>
    </section>
  );
}